// extracted by mini-css-extract-plugin
module.exports = {"list":"participantList-module--list--2svkS","disabled":"participantList-module--disabled--1fjWX"};